import { useEffect, useState } from "react";

export const useWindowWidth = (size: number) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < size);
  }, [window.innerWidth]);

  return isMobile;
};
